import { render, staticRenderFns } from "./metemail.vue?vue&type=template&id=38a8b618"
import script from "./metemail.vue?vue&type=script&lang=js"
export * from "./metemail.vue?vue&type=script&lang=js"
import style0 from "./metemail.vue?vue&type=style&index=0&id=38a8b618&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports